/**
 * Seiten-Scroll an oder aus (Benedikt 28.09.2026): Am Handy scrollt die ganze
 * Seite statt des Reader-Kastens, damit Safari die Browser-Leiste einklappt.
 *
 * - `standard`: Vorgabe der Umgebung (PUBLIC_VIEWER_SEITENSCROLL, nur dev an).
 * - `param`: `?seitenscroll=` im Link; "1" schaltet ein, "0" aus, alles
 *   andere laesst die Vorgabe gelten.
 *
 * Ob der Reader den Seiten-Scroll dann wirklich nutzt, entscheidet
 * ViewerChrome zusaetzlich nach Geraet (nur Handy-Vollbild, nie eingebettet).
 */
export function seitenScrollAn(param: unknown, standard: boolean): boolean {
  if (param === "1") return true;
  if (param === "0") return false;
  return standard;
}

/**
 * Ob der Reader den Seiten-Scroll wirklich nutzt (Befund 29.09.2026, Hero auf
 * welcome.scrolly.com "kaputt"): Die Scroll-Engine wird EINMAL beim Start mit
 * ihrer Quelle (Kasten oder Fenster) angelegt und folgt spaeteren Wechseln
 * nicht. Deshalb darf die Entscheidung nur aus Werten kommen, die Server und
 * Client von der ersten Zeichnung an gleich sehen:
 *
 * - `initialIsMobile` (UA-Hinweis des Servers): Ein Desktop-Browser in einem
 *   schmalen Fenster oder iframe startet als Desktop (Kasten-Scroll), wird nach
 *   dem Laden per matchMedia "compact" und wuerde sonst auf Seiten-Scroll
 *   umschalten, waehrend die Engine weiter den Kasten abhoert: das Bild
 *   scrollt weg, nur die Overlays bleiben.
 * - `imIframe` (Server: Sec-Fetch-Dest: iframe): Eingebettet gibt es keine
 *   Browser-Leiste, die sich einklappen koennte; Seiten-Scroll im iframe
 *   bringt nichts und brach den Hero der Website.
 */
export function seitenScrollNutzbar(a: {
  seitenScrollTest: boolean;
  isOg: boolean;
  isEmbedded: boolean;
  imIframe: boolean;
  initialIsMobile: boolean;
  isMobileViewport: boolean;
  wide: boolean;
}): boolean {
  return (
    a.seitenScrollTest &&
    !a.isOg &&
    !a.isEmbedded &&
    !a.imIframe &&
    a.initialIsMobile &&
    a.isMobileViewport &&
    a.wide
  );
}
